"use client";

import Image from "next/image";
import DoctorNeetMobile from "@/components/newPageComponent/mbbs/DoctorNeetMobile";
import DoctorTimelineMobile from "@/components/newPageComponent/mbbs/DoctorTimelineMobile";
import DoctorHowUSPathwayMobile from "@/components/newPageComponent/mbbs/DoctorHowUSPathwayMobile";
import DoctorResidencyMobile from "@/components/newPageComponent/mbbs/DoctorResidencyMobile";
// import HeadHealth from "@/components/pageComponent/healthcare/doctors/ui/head";
import DoctorBannerMobile from "@/components/newPageComponent/mbbs/DoctorBannerMobile";
import dynamic from "next/dynamic";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const DoctorNeetAspirantsMobile = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorNeetAspirantsMobile"),
  {
    ssr: false,
  },
);

const DoctorStudyNorthAmericaMobile = dynamic(
  () =>
    import("@/components/newPageComponent/mbbs/DoctorStudyNorthAmericaMobile"),
  {
    ssr: false,
  },
);

const DoctorClinicalUSAMobile = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorClinicalUSAMobile"),
  {
    ssr: false,
  },
);

const DoctorFAQs = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorFAQs"),
  {
    ssr: false,
  },
);

const DoctorUSPathwayMobile = dynamic(
  () => import("@/components/newPageComponent/mbbs/DoctorUSPathwayMobile"),
  {
    ssr: false,
  },
);

// const DoctorMbbsMdAmericaMobile = dynamic(
//   () => import("@/components/newPageComponent/mbbs/DoctorMbbsMdAmericaMobile"),
//   {
//     ssr: false,
//   },
// );

const MobilePage = () => {
  return (
    <div className="w-full bg-white">
      <div className="w-full">
        <div className="bg-[#061A2F] relative">
          <Image
            src="/CPA_New/mob/banner_bg_mob.png"
            alt="stars"
            className="absolute left-[0] top-[0] w-[auto]"
            width={360}
            height={736}
            priority
          />
          <GlobalHeaderNew />
          <div className="w-full" id="banner-mob">
            <DoctorBannerMobile />
          </div>
        </div>
        <div className="w-full" id="pathway-mob">
          <DoctorUSPathwayMobile />
        </div>
        <div className="w-full" id="neet-mob">
          <DoctorNeetMobile />
        </div>
        <div className="w-full" id="timeline-mob">
          <DoctorTimelineMobile />
        </div>
        <div className="w-full" id="timeline-mob">
          <DoctorHowUSPathwayMobile />
        </div>
        <div className="w-full" id="study-mob">
          <DoctorStudyNorthAmericaMobile />
        </div>
        <div className="bg-white bg-no-repeat bg-[url('/CPA_New/mob/powered_miles_bg.png')] bg-[0%_55%]">
          <div className="w-full" id="clinical-mob">
            <DoctorClinicalUSAMobile />
          </div>
        </div>
        <div className="w-full" id="residency-mob">
          <DoctorResidencyMobile />
        </div>
        {/* <div className="w-full">
          <DoctorMbbsMdAmericaMobile />
        </div> */}
        <div className="bg-[#061A2F] pb-10 relative">
          <Image
            src="/healthcare/doctors/new-mob/bg.png"
            alt="stars"
            className="absolute right-0 top-[500px]"
            width={275}
            height={260}
            priority
          />
          <div className="w-full" id="aspirants-mob">
            <DoctorNeetAspirantsMobile />
          </div>
          <div className="w-full" id="faq-mob">
            <DoctorFAQs />
          </div>
        </div>
        <div className="w-full">
          <GlobalFooter />
        </div>
      </div>
    </div>
  );
};

export default MobilePage;
